import { StatusTable } from "../../../../src/components/status";
import * as React from 'react';
export default {
  StatusTable,
  React
};